import React from "react"
import Layout from "../components/layout"
import Seo from "../components/seo"
import BumpMindbody from "../components/mindbody-bump"
import ErrorBoundary from "../components/error-boundary"
import { AnchorLink } from "gatsby-plugin-anchor-links"
import { StaticImage } from "gatsby-plugin-image"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faGooglePlay, faAppStoreIos } from "@fortawesome/free-brands-svg-icons"
import QRsvg from "../assets/register.svg"
import { ArrowSmDownIcon, CheckIcon } from "@heroicons/react/outline"

const FirstTimePage = () => {
  return (
    <Layout>
      <Seo title="First Time" />
      <div className="bg-stone-100 normal-case">
        <div>
          <div className="flex justify-center  px-8 py-8 shadow-sm md:py-12 md:px-40">
            <p className="font-Roboto text-5xl font-bold lowercase text-bump-gray md:text-7xl">
              newbies here.
            </p>
          </div>
        </div>

        <section className="min-h-screen bg-stone-100  text-gray-600">
          <div className="container mx-auto px-5 py-24">
            {/* <div className="mx-auto mb-10 flex flex-col items-center border-b border-gray-200 pb-10 sm:flex-row lg:w-3/5">
              <div className="inline-flex h-20 w-20 flex-shrink-0 items-center justify-center rounded-full bg-amber-200 text-amber-600 sm:mr-10 sm:h-48 sm:w-48">
                <QRsvg width="15rem" />
              </div>
              <div className="mt-6 flex-grow text-center sm:mt-0 sm:text-left">
                <h2 className=" mb-2 font-Roboto text-3xl font-bold text-gray-900">
                  Create an account.
                </h2>
                <p className="text-base leading-relaxed">
                  Before you can climb with us, you'll need to create an account
                  on our companion application! It's at the bottom of the page,
                  but we'll guide you there slowly.
                </p>
              </div>
            </div> */}
            <div className="mx-auto mb-10 flex flex-col items-center border-b border-gray-200 pb-10 sm:flex-row lg:w-3/5">
              <div className="mt-6 flex-grow text-center font-OpenSans sm:mt-0 sm:text-left">
                <h2 className="mb-2 font-Roboto text-5xl font-bold lowercase text-bump-blue">
                  first timer registration.
                </h2>
                <p className="text-base leading-relaxed">
                  If you are a first time customer, you'll need to register an
                  account before you can begin climbing.
                </p>
                <br />
                <p className="text-base leading-relaxed">
                  If you already have an account, you can proceed to the counter
                  to make payment.
                </p>
                <br />
                <p className="text-base leading-relaxed">
                  If you are looking to make a booking for a course, you can{" "}
                  <span>
                    {" "}
                    <AnchorLink
                      to="/first-time#booking"
                      className="mt-3 inline-flex items-center text-amber-600"
                    >
                      book here
                      <svg
                        fill="none"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        className="ml-2 h-4 w-4"
                        viewBox="0 0 24 24"
                      >
                        <path d="M5 12h14M12 5l7 7-7 7"></path>
                      </svg>
                    </AnchorLink>
                  </span>
                </p>
              </div>
              <div className="order-first inline-flex h-20 w-20 flex-shrink-0 items-center justify-center rounded-full bg-amber-200 text-amber-600 sm:order-none sm:ml-10 sm:h-48 sm:w-48">
                <QRsvg width="15rem" />
              </div>
            </div>

            <div className="mx-auto flex flex-col items-center sm:flex-row lg:w-3/5">
              <div>
                <div className=" lg:pr-16">
                  <div className="flex">
                    <div className="mr-4  flex flex-col items-center">
                      <div className="">
                        <div className="flex h-12 w-12 items-center justify-center rounded-full  bg-bump-blue">
                          <ArrowSmDownIcon className="h-7 text-stone-100 " />
                        </div>
                      </div>
                      <div className="h-full w-1.5 bg-bump-blue"></div>
                    </div>
                    <div className=" pb-16">
                      <p className="font-Roboto text-4xl font-bold text-bump-blue">
                        step 1.
                      </p>

                      <p className="mt-2 font-OpenSans text-base text-stone-700">
                        Scan the QR code or scroll below to find our widget.
                      </p>
                    </div>
                  </div>

                  <div className="flex">
                    <div className="mr-4 flex flex-col items-center">
                      <div className="">
                        <div className="flex h-12 w-12 items-center justify-center rounded-full bg-bump-blue">
                          <ArrowSmDownIcon className="h-7 text-stone-100 " />
                        </div>
                      </div>
                      <div className="h-full w-1.5 bg-bump-blue"></div>
                    </div>
                    <div className=" pb-16">
                      <p className="font-Roboto text-4xl font-bold text-bump-blue">
                        step 2.
                      </p>

                      <p className="mt-2 font-OpenSans text-base text-stone-700">
                        Tap the "login/register" tab and proceed with the
                        registration.
                      </p>
                    </div>
                  </div>
                  <div className="flex">
                    <div className="mr-4 flex flex-col items-center">
                      <div className="">
                        <div className="flex h-12 w-12 items-center justify-center rounded-full bg-bump-blue">
                          <CheckIcon className="h-7 text-stone-100 " />
                        </div>
                      </div>
                    </div>
                    <div className=" pb-8">
                      <p className="font-Roboto text-4xl font-bold text-bump-blue">
                        done!
                      </p>

                      <p className="mt-2 font-OpenSans text-base text-stone-700">
                        Check in at the front counter!
                        <br /> <br />
                        If you'd like to have an express check-in, scroll below
                        to download our dedicated app and login with the same
                        details you used to register.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="inline-flex h-20 w-20 flex-shrink-0 items-center justify-center rounded-full bg-amber-200 text-amber-600 sm:mr-10 sm:h-32 sm:w-32">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-16 w-16"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5"
                  />
                </svg>
              </div>
              <div className="mt-6 flex-grow text-center sm:mt-0 sm:text-left">
                <h2 className=" mb-2 font-Roboto text-3xl font-bold  text-gray-900">
                  Congratulations!
                </h2>
                <p className="text-base leading-relaxed">
                  And that's it! It was pretty easy wasn't it? <br />
                  <br /> You can use the same log in details on our application
                  that you can find on the Google Playstore as well as the Apple
                  App Store. Just look for "Bump Bouldering" and you'll have
                  access to your account information as well as a faster
                  check-in the next time you visit us.
                </p>
              </div> */}
            </div>
          </div>
        </section>

        <section className="bg-bump-gray ">
          <div className="container mx-auto flex flex-col items-center px-4 py-24 xl:flex-row">
            <div className="flex justify-center xl:w-1/2">
              <StaticImage
                className="h-80 w-80 flex-shrink-0 rounded-full object-cover sm:h-[28rem] sm:w-[28rem]"
                src="https://images.unsplash.com/photo-1551650975-87deedd944c3?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1974&q=80"
                alt=""
              />
            </div>

            <div className="mt-6 flex flex-col items-center xl:mt-0 xl:w-1/2 xl:items-start">
              <p className="font-roboto text-2xl font-bold tracking-tight text-stone-100 xl:text-5xl">
                Download our free mobile app
              </p>

              <p className="mt-4 block max-w-2xl text-xl text-stone-300 ">
                Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iusto
                recusandae tenetur iste quaerat voluptatibus quibusdam nam
                repudiandae{" "}
              </p>
              <div className="mt-6 sm:-mx-2">
                <div className="mt-4 inline-flex w-full overflow-hidden rounded-sm shadow sm:mx-2 sm:mt-0 sm:w-auto">
                  <a
                    href="https://apps.apple.com/us/app/bump-bouldering/id1623580625?uo=2"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex w-full transform items-center justify-center bg-gradient-to-r from-blue-700 to-blue-900 px-5 py-3 text-base font-medium text-white transition-colors duration-150 hover:from-blue-600 hover:to-blue-600 sm:w-auto"
                  >
                    <FontAwesomeIcon size="xl" icon={faAppStoreIos} />
                    <span className="mx-2">Get it on the App Store</span>
                  </a>
                </div>

                <div className="mt-4 inline-flex w-full overflow-hidden rounded-sm shadow sm:mx-2 sm:mt-0 sm:w-auto">
                  <a
                    href="https://play.google.com/store/apps/details?id=com.fitnessmobileapps.bumpbouldering"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex w-full transform items-center justify-center bg-gradient-to-r from-green-700 to-green-900 px-5 py-3 text-base font-medium text-white transition-colors duration-150 hover:from-green-600 hover:to-green-600 sm:w-auto"
                  >
                    <FontAwesomeIcon size="xl" icon={faGooglePlay} />
                    <span className="mx-2">Get it on Google Play</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="pt-24 pb-24">
          <div className="flex justify-center bg-stone-800 px-8 py-8 shadow-sm md:py-12 md:px-40">
            <p id="booking" className="banner-title lowercase">
              The Booking Thing.
            </p>
          </div>
          <div className="mt-12">
            {/* <ErrorBoundary>
              <BumpMindbody />
            </ErrorBoundary> */}
            <div className=" mt-4 px-6 md:mt-12 md:px-36">
              <iframe
                title="Glofox Widget"
                src="https://app.glofox.com/portal/#/branch/5c52e8f40c5d280ed1713263/courses"
                frameborder="0"
                width="100%"
                height="1200"
              ></iframe>
              <a href="https://www.glofox.com">
                powered by <b>Glofox</b>
              </a>
            </div>
          </div>
        </section>
      </div>
    </Layout>
  )
}

export default FirstTimePage
